import isMobile from 'ismobilejs';

export default {

    methods: {

        isMobile(){
            return isMobile(window.navigator).any
        },

        ucfirst(value){
            if (!value) return ''
            value = value.toString()
            return value.charAt(0).toUpperCase() + value.slice(1)
        },

        dateParse(date) {
            return moment.tz(date, 'utc').tz(clientTimeZone)
        },

        diffForHumans(date) {
            if (!isNaN(date)) {
                date = date * 1000;
            }
            return this.dateParse(date).fromNow();
        },

        classicDate(date, fallback = 'Not Defined') {
            if(date == null) return fallback;
            return this.dateParse(date).format('Y-MM-DD');
        },

        mysqlDateTime(date, fallback = 'Not Defined') {
            if(date == null) return fallback;
            return this.dateParse(date).format('Y-MM-DD H:mm:ss');
        },

        longDateTime(date, fallback = 'Not Defined') {
            if(date == null) return fallback;
            return this.dateParse(date).format("MMMM DD, YYYY hh:mm:ss A");
        },

        shortDateTime(date, fallback = 'Not Defined') {
            if(date == null) return fallback;
            return this.dateParse(date).format("MMMM DD, YYYY \\a\\t hh:mm A");
        },

        shortDate(date, fallback = 'Not Defined') {
            if(date == null) return fallback;
            return this.dateParse(date).format("MMMM DD, YYYY");
        },

        dateCalendar(date, fallback = 'Not Defined') {
            if(date == null) return fallback;
            return this.dateParse(date).calendar();
        },

        monthName(month) {
            return moment(month, 'MM').format('MMMM');
        },

        redirectTo(url, type) {
            if (type == '_blank') {
                window.open(url, type);
                return;
            }
            window.location.href = url;
        },

        refreshPage() {
            window.location.reload();
        },

        strlimit(str, max = 30, characters = '...') {
            var sub = str.substring(0, max);
            return (sub != str) ? sub + characters : sub;
        },

        pluralize(string, count) {
            return pluralize(string, count);
        },

        isMobileDevice() {
            return $(window).width() < 960
        }
    },
}
